import { REFRESHTOKEN_FAIL, REFRESHTOKEN_SUCCESS } from '../actionTypes';

const initialState = {
	user: null
};

const refreshTokenReducer = (state = initialState, action) => {
	switch (action.type) {
		case REFRESHTOKEN_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				user: action.payload.user,
			};
		case REFRESHTOKEN_FAIL:
			return {
				...state,
				isLoggedIn: false,
				user: null,
			};
		default:
			break;
	}

	return state;
};

export default refreshTokenReducer;
